import { isServer } from './env-helper';

export const centerOpener = (url: string, title: string, w: number, h: number): void => {
  if (isServer) return;
  // NOTE: Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft = window.screenLeft ?? window.screenX;
  const dualScreenTop = window.screenTop ?? window.screenY;
  const width = window.innerWidth ?? document.documentElement.clientWidth ?? window.screen.width;
  const height = window.innerHeight ?? document.documentElement.clientHeight ?? window.screen.height;
  const left = width / 2 - w / 2 + dualScreenLeft;
  const top = height / 2 - h / 2 + dualScreenTop;
  const newWindow = window.open(url, title, `scrollbars=no, width=${w}, height=${h}, top=${top}, left=${left}`);
  // Puts focus on the newWindow
  newWindow?.focus();
};
